<template> 
<div>
  <el-overlay-loading :loading="loading" />
    <v-autocomplete
    outlined
    dense
    background-color="white"
    persistent-placeholder
    :class="compClass +
      ((getForAccessibility) ? ' for-accessibility-app ' : '')"
    :filter="onFilter"
    v-model="elValue"
    :items="getItems"
    :label="translateLabel"
    :item-text="itemtext"
    :item-value="itemvalue"
    :return-object="returnObject"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonlyElement"
    :multiple="multiple"
    @change="change"
    @blur="onBlur"
    @focus="onFocus"
    v-validate="validateRules"
    :data-vv-name="validateName"
    :error-messages="errorMessages"
    :data-vv-validate-on="required ? 'input' : 'change'"
    :autofocus="autofocus"
    :hide-details="hideDetails"
    :search-input.sync="search"
    :menu-props="getProps"
  >
    <template v-if="longText" v-slot:selection="{ item }">
      <v-col v-if="seperate" cols="12" class="pa-0 py-1">{{ item.text }}</v-col>
      <span v-else style="word-break: break-word" class="mt-1">{{
        item.text
      }}</span>
    </template>
    <template v-if="tooltip" slot="label">
      <div style="display: flex">
        <span class="label-text">{{ `${translateLabel}` }}</span>
        <div style="color: red" v-if="required">*</div>
        <span v-if="emptyLine" style="white-space: pre; color: white">{{ `___` }}</span>
        <el-tooltip slot="append-outer" @addEmptyLine="addEmptyLine" :tooltip="tooltip" input />
      </div>
    </template>
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          {{ noData }}
        </v-list-item-title>
      </v-list-item>
    </template>
     <template v-if="showListSelectBtnAdd" slot="append">
        <slot name="append">
          <v-hover close-delay="500" v-slot="{ hover }">
            <el-button
              small
              outlined
              class="select-input-btn mr-1"
              color="primary"
              :icon="hover ? '' : 'pridėti'"
              @click.native="addAll()"
            >
              <div v-if="hover">
                {{ $t('Pridėti visas') }}
              </div>
            </el-button>
          </v-hover>
        </slot>
      </template>
  </v-autocomplete>
</div>
</template>

<script>
import errorNotifications from '@/mixins/errorNotifications'
import { transliterate as tr } from 'transliteration'
import { mapGetters } from 'vuex'

export default {
  name: 'ElAutocomplete',
  mixins: [errorNotifications],
  props: {
    classP: String,
    label: String,
    placeholder: { type: String, default: ' ' },
    items: [Object, Array],
    itemtext: String,
    itemvalue: String,
    returnObject: Boolean,
    required: Boolean,
    need: Boolean,
    tooltip: String,
    value: [String, Number, Object, Array, Boolean],
    predefinedOrder: { type: [Array, Boolean], default: false },
    disabled: Boolean,
    readonly: Boolean,
    multiple: Boolean,
    validateKey: String,
    autofocus: { type: Boolean, default: false },
    enums: { type: Boolean, default: false },
    direct: { type: Boolean, default: false },
    autoSelector: { type: Boolean, default: false },
    hideDetails: [Boolean, String],
    longText: Boolean,
    seperate: Boolean,
    inFragments: Boolean,
    lockSearch: Boolean,
    highestLevel: Boolean,
    listSelect: Boolean,
  },
   data() {
    return {
      emptyLine: false,
      loading: false,
      search: null,
      focus: false
    }
  },
  inject: {
    $validator: '$validator',
  },
  watch: {
    elValue() {
      this.search = ''
    },
    search() {
      if(!this.multiple && this.lockSearch && this.elValue){
         this.$nextTick(() => {
          this.search = ''
        })
      }
    }
  },
  computed: {
    ...mapGetters(['getForAccessibility']),
    getProps(){
      if(this.getForAccessibility && this.highestLevel){
        return { zIndex: 100, filter: 'grayscale(100)' }
      } else if(this.getForAccessibility) {
         return {
            contentClass: 'for-accessibility-app', 
        };
      }
      return this.highestLevel ? { zIndex: 100 }: ''
    },
    showListSelectBtnAdd(){
     return this.listSelect
      // return this.listSelect && this.focus
    },
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
    getItems() {
      if (this.items && !this.enums && !this.direct) {
        return this.$i18n.locale === 'lt' ? this.items.lt : this.items.en
      } else if (this.enums) {
        let arr = this.$i18n.locale === 'lt'
          ? Object.keys(this.items.lt).map((key) => {
              return { text: this.items.lt[key], value: key }
            })
          : Object.keys(this.items.en).map((key) => {
              return { text: this.items.en[key], value: key }
            })
          if(this.predefinedOrder){
            return this.predefinedOrder.map((key) => ({
              value: key,
              text: arr.find(item => item.value == key).text,
            }));
          }
          return arr
      } else if (this.direct) {
        return this.items
      } else {
        return []
      }
    },

    noData() {
      return this.$t('Nėra duomenų')
    },

    translateLabel() {
      return this.$t(this.label)
    },

    validateName() {
      return this.validateKey || this.label
    },
    validateMessages() {
      return {
        'field is required':
          this.notificationText('000006') || this.$t('Laukas privalomas'),
      }
    },
    validateRules() {
      let rule = ''
      rule = this.required ? 'required' : ''
      return rule
    },
    errorMessages() {
      let name = this.validateKey || this.label
      const messages = this.errors.collect(name)
      if (messages.length > 0) {
        const key = Object.keys(this.validateMessages).find((item) =>
          messages[0].includes(item)
        )
        return this.validateMessages[key]
      } else {
        return ''
      }
    },
    requiredClass() {
      return (this.required || this.need) && !this.readonlyElement
        ? 'required-input'
        : ''
    },
    compClass() {
      return `${this.classP} ${this.requiredClass} labelPatch`
    },
    readonlyElement() {
      return this.readonly || (this.autoSelector && this.getItems.length === 1)
    },
  },
  created() {
    this.autoSelector && this.autoSelect()
  },
  methods: {
    onBlur(e){
      this.search = ''
      // !this.enums ?? (this.search = '')
      this.focus = false
    },
    onFocus(e){
      this.focus = true
    },
    addEmptyLine(value){
      this.emptyLine = value
    },
    searchInFragments(item, queryText){
      let logicArr = []
      queryText.split(' ').map(fragment =>{
        if(fragment == ''){return}
        let logic = tr(item.text).toLowerCase().includes(tr(fragment).toLowerCase()) ||
        tr(this.$i18n.locale === 'lt' ? item.title_lt : item.title_en)
          .toLowerCase()
          .includes(tr(fragment).toLowerCase())
        logicArr.push(logic)
      })
      return logicArr.every(element => element)
    },
    onFilter(item, queryText, itemText) {
      if(this.inFragments){
        return this.searchInFragments(item, queryText)
      } else {
        return (
        tr(item.text).toLowerCase().includes(tr(queryText).toLowerCase()) ||
        tr(this.$i18n.locale === 'lt' ? item.title_lt : item.title_en)
          .toLowerCase()
          .includes(tr(queryText).toLowerCase())
        )
      }
    },
    change() {
      this.$emit('change')
    },
    autoSelect() {
      if (this.getItems.length === 1) {
        let value = this.returnObject
          ? this.getItems[0]
          : this.getItems[0][this.itemvalue]
        this.elValue = this.multiple ? [value] : value
      }
    },
    addAll(){
      this.loading = true;
       setTimeout(() => {
          let filered = []
          if(this.search){
            filered = this.getItems.filter((item) => {
              return this.searchInFragments(item, this.search);
            });
          } else {
            filered = this.getItems
          }
          this.$nextTick(() => {
            this.loading = false
            this.$emit('add-all', filered.map(obj => obj.value))
            this.search = ''
          })
        }, 1000)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/elements.scss';
.select-input-btn {
  height: 25px !important;
  min-width: 23px !important;
  padding: 0px 4px 0px 4px !important;
}
</style>
